/* unplugin-vue-components disabled */import { render } from "./imgSwipers.vue?vue&type=template&id=0397ab10&scoped=true"
import script from "./imgSwipers.vue?vue&type=script&lang=js"
export * from "./imgSwipers.vue?vue&type=script&lang=js"

import "./imgSwipers.vue?vue&type=style&index=0&id=0397ab10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0397ab10"]])

export default __exports__